import React, { useState, useEffect, useRef } from "react";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import AppTopBar2 from '../common/app-top-bar2';
import AppLoading from '../common/app-loading';
import {
  Box, Divider, List, ListItem, ListItemButton, Paper, Typography, 
  Table, TableContainer, TableCell, TableHead, TableBody, TableRow, TableSortLabel,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { AppHelper } from '../../AppHelper';
import SpaCheck from '../common/spa-check';
import PageQuestion from '../sentence-transformation/question-set';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary" fontSize={"0.7rem"}
          sx={{
            color: props.recSelected == 1 ? '#fff' : 'text.secondary'
          }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsEssay = [
  { id: 'createdOn', numeric: false, disablePadding: false, label: 'TIMESTAMP' },
  { id: 'uploadType', numeric: false, disablePadding: false, label: 'OWNERSHIP' },
  { id: 'title', numeric: false, disablePadding: false, label: 'TITLE' },
  { id: 'grade', numeric: false, disablePadding: false, label: 'GRADE' },
  { id: 'createdByName', numeric: false, disablePadding: false, label: 'CREATED BY' },
  { id: 'actions', numeric: false, disablePadding: false, label: 'ACTIONS' }

];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const headCells = headCellsEssay;


  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function QuestionSetListTable({
  filterLog, popQuestionOpenParam, onClose, mode
}) {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();
  const [popQuestionOpen, setPopQuestionOpen] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [logList, setLogList] = useState([]);

  const popQuestionClose = (refresh) => {	
    setSelectedRow(null);	
    setRefreshList(refresh === true);
    setPopQuestionOpen(false);
	if (onClose)
	{
		onClose(false);
	}
  }

  useEffect(() => {
    AppHelper.apiAuditPost("P-QS", "");
    var _user = AppHelper.userCacheGet();
    if (_user) {
      fetchIAM(_user);
	  
    }
  }, []);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState('LIST');
  const [refreshList, setRefreshList] = React.useState(true);
  const [countEssay, setCountLog] = React.useState(0);

  const [tblOrderLog, setTblOrderLog] = React.useState('desc');
  const [tblOrderByLog, setTblOrderByEssay] = React.useState('tCode');
  const [isSa, setIsSa] = useState(false);

  const fetchIAM = async (oUser) => {
    var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
    if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
      return;
    }
    setIsSa(true);
  }

  const fetchRowData = async (row) => {
    var _res = await AppHelper.apiPost('api/exercise/sentenceTransform/questionSet/get', { token: oUser.token, questionSetId: row.questionSetId});
    if (!_res  || !_res.data ) {
      return;
    }
    const dataWithGrade = {
      ..._res.data, 
      questionSetName: row.questionSetName,
      questionSetId: row.questionSetId,
      uploadType: row.uploadType, 
      saQuestion: row.saQuestion, 
      grade: row.grade
    }
    setSelectedRowData(dataWithGrade);
    return _res.data;
  }

  useEffect(() => {
    if (!oUser) {
      navigate('/login');
      return;
    }
  });

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const questionEdit = async (row) => {
    setSelectedRow(row);
    const _res = await fetchRowData(row);
    if (!_res){
      console.error("Failed to fetch data for editing: ", _res);
    }
    setPopQuestionOpen(true);
  };
  const fetchLogList = async () => {
	var _res = await AppHelper.apiPost('api/account/iam', { token: oUser.token });
    logList.splice(0);
    setIsLoading(true);
    
    if (_res && _res.status && _res.data) {
      var url = 'api/exercise/sentenceTransform/questionSet/list';
    }

    var _res = await AppHelper.apiPost(url, { token: oUser.token });
    if (!_res || !_res.status) {
      setIsLoading(false);
      return;
    }
    var _list = [...AppHelper.sortList(_res.questionList, 'createdOn', 2)];
	_list.map((row)=>{
		row.ownershipText = row.saQuestion == 1 ? "SYSTEM" : row.uploadType == 0 ? "SELF" : "TUITION CENTER "
	});
    setLogList(_list);
    setIsLoading(false);
    setCountLog(_list.length);
    setRefreshList(false);
  };

  useEffect(() => {
    if(refreshList)
	{	
		fetchLogList();
	}

  }, [refreshList]);

  const questionDelete = async (arg) => {
    if (!window.confirm("Are you sure you want to delete the Question Set?")) return;
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/exercise/sentenceTransform/questionSet/delete", {
      token: oUser.token, 
      questionSetId: arg.questionSetId,
    });
    if (!_res || !_res.status) {
      alert("ERROR: Failed to delete!");
      setIsLoading(false);
      return;
    }
    setRefreshList(true);
  };

  const drawerItemColrs = {
    '1x': 'rgba(0,0,0,0.25)',
    '1xx': 'rgb(157, 188, 152)',
    '1': 'rgb(99, 136, 137)',
    '0x': 'white',
    '0': 'rgb(235, 217, 180)',
  };
  const drawerItemColorsText = {
    '1': 'rgba(255,255,255,1)',
    '0': 'rgba(0,0,0,0.6)',
  };
  
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  
  const listSortAndFilterEssay = () => {
    var _list = [...logList];
    if (filterLog && filterLog.length > 0) {
      var _filterText = filterLog.toLowerCase();
      _list = _list.filter(r =>
       (r.title && r.title.toLowerCase().includes(_filterText))
	   || (r.questionSetName && r.questionSetName.toLowerCase().includes(_filterText))
	   || (r.ownershipText && r.ownershipText.toLowerCase().includes(_filterText))
        || (r.grade && r.grade.toLowerCase().includes(_filterText))
        || (r.createdByName && r.createdByName.toLowerCase().includes(_filterText))

      );
    }
    return stableSort(_list, getComparator(tblOrderLog, tblOrderByLog));
  };
  
  const visibleLogs = React.useMemo(
    () =>
      listSortAndFilterEssay(),
    [logList, tblOrderLog, tblOrderByLog, filterLog]
  );
  const tblSortLog = (event, property) => {
    const isAsc = tblOrderByLog === property && tblOrderLog === 'asc';
    setTblOrderLog(isAsc ? 'desc' : 'asc');
    setTblOrderByEssay(property);
  };
  
  useEffect(() => {    
  setSelectedRowData(null);
	setPopQuestionOpen(popQuestionOpenParam);
  }, [popQuestionOpenParam]);

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
        {isLoading ? (
          <AppLoading />
        ) : (
          <>
              {viewMode == 'LIST' &&
                <>
                 
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <EnhancedTableHead
                        order={tblOrderLog}
                        orderBy={tblOrderByLog}
                        onRequestSort={tblSortLog}
                        rowCount={logList.length}
                        gid='G1'
                      />
                      <TableBody>
                        {visibleLogs.map((row) => (
                          <TableRow
                            key={row.logId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell align="left">{new Date(row.createdOn).toLocaleString()}</TableCell>
                            <TableCell align="left">{row.saQuestion == 1 ? "SYSTEM" : row.uploadType == 0 ? "SELF" : "TUITION CENTER "}</TableCell>
                            <TableCell align="left">{row.questionSetName}</TableCell>
                            <TableCell align="left">{row.grade}</TableCell>
                            <TableCell align="left">{row.createdByName}</TableCell>
                            <TableCell>
							  {!(!isSa && row.saQuestion === 1) && (
								<IconButton
								  onClick={() => questionEdit(row)}
								  aria-label="edit"
								>
								  <EditIcon />
								</IconButton>
							  )}
							  {!(!isSa && row.saQuestion === 1) && (
								<IconButton
								  onClick={() => questionDelete(row)}
								  aria-label="delete"
								>
								  <DeleteForeverIcon />
								</IconButton>
							  )}
							</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              }
          </>
        )}
        <SpaCheck></SpaCheck>
      </Box>
      <PageQuestion
        model={selectedRowData}
        open={popQuestionOpen}
        onClose={popQuestionClose}
        mode = {mode}
      />
    </>
  );

}